import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  BETWEEN_HOURS,
  MENU_HOURS_EXPIRED,
  CHANGE_LOCATION,
  CART_ITEMS_EXPIRED,
  CART_NOT_FOUND,
  CHECKOUT_NOT_POSSIBLE,
  PROMOTION_DETAILS,
  FULFILLMENT_OPTION_NOT_AVAILABLE,
  MODIFIER_NOT_FOUND,
  MENU_ITEM_NOT_ON_CURRENT_MENU,
  FILTERED_MENU_ITEM_NOT_ON_CURRENT_MENU
} from 'bento-ordering/cart/constants/notificationTypes';
import BetweenMenusNotificationContainer from 'bento-ordering/base/containers/BetweenMenusNotificationContainer';
import MenuHoursExpiredNotificationContainer from 'bento-ordering/base/containers/MenuHoursExpiredNotificationContainer';
import LocationChangedNotificationContainer from 'bento-ordering/base/containers/LocationChangedNotificationContainer';
import CartItemsExpiredNotificationContainer from 'bento-ordering/base/containers/CartItemsExpiredNotificationContainer';
import CartNotFoundNotification from 'bento-ordering/base/components/CartNotFoundNotification';
import CheckoutNotPossibleNotification from 'bento-ordering/base/components/CheckoutNotPossibleNotification';
import { closeNotificationModal } from 'bento-ordering/base/actions/notificationModals';
import PromotionDetailsNotification from 'bento-ordering/promotions/components/PromotionDetailsNotification';
import MenuItemNotOnCurrentMenuNotification from 'bento-ordering/promotions/components/MenuItemNotOnCurrentMenuNotification';
import MenuItemNotOnCurrentMenuFilteredItemNotification from 'bento-ordering/promotions/components/MenuItemNotOnCurrentMenuFilteredItemNotification';
import ModalRoot from 'bento-ordering/base/containers/ModalRoot';
import FulfillmentOptionNotAvailableNotNotification from 'bento-ordering/base/components/FulfillmentOptionNotAvailableNotification';
import ModifierNotFoundNotification from 'bento-ordering/base/components/ModifierNotFoundNotification';

class NotificationModalContainer extends React.Component {
  static propTypes = {
    notificationModalType: PropTypes.oneOf([
      BETWEEN_HOURS,
      MENU_HOURS_EXPIRED,
      CHANGE_LOCATION,
      CART_ITEMS_EXPIRED,
      CART_NOT_FOUND,
      CHECKOUT_NOT_POSSIBLE,
      PROMOTION_DETAILS,
      FULFILLMENT_OPTION_NOT_AVAILABLE,
      MODIFIER_NOT_FOUND,
      MENU_ITEM_NOT_ON_CURRENT_MENU,
      FILTERED_MENU_ITEM_NOT_ON_CURRENT_MENU
    ]),
    dispatch: PropTypes.func,
    modalProps: PropTypes.object
  };

  closeModal = () => {
    this.props.dispatch(closeNotificationModal());
  };

  render() {
    const { notificationModalType, modalProps } = this.props;
    return (
      <ModalRoot>
        {notificationModalType === BETWEEN_HOURS && (
          <BetweenMenusNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === MENU_HOURS_EXPIRED && (
          <MenuHoursExpiredNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CHANGE_LOCATION && (
          <LocationChangedNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CART_ITEMS_EXPIRED && (
          <CartItemsExpiredNotificationContainer closeModal={this.closeModal} />
        )}
        {notificationModalType === CART_NOT_FOUND && (
          <CartNotFoundNotification closeModal={this.closeModal} />
        )}
        {notificationModalType === FULFILLMENT_OPTION_NOT_AVAILABLE && (
          <FulfillmentOptionNotAvailableNotNotification
            closeModal={this.closeModal}
          />
        )}
        {notificationModalType === CHECKOUT_NOT_POSSIBLE && (
          <CheckoutNotPossibleNotification
            closeModal={this.closeModal}
            message={modalProps.message}
            fullWidth={modalProps.fullWidth}
          />
        )}
        {notificationModalType === MENU_ITEM_NOT_ON_CURRENT_MENU && (
          <MenuItemNotOnCurrentMenuNotification closeModal={this.closeModal} />
        )}
        {notificationModalType === FILTERED_MENU_ITEM_NOT_ON_CURRENT_MENU && (
          <MenuItemNotOnCurrentMenuFilteredItemNotification
            closeModal={this.closeModal}
          />
        )}
        {// TODO: https://getbentobox.atlassian.net/browse/EC-1446 explore adding the notification handling elsewhere
        notificationModalType === PROMOTION_DETAILS && (
          <PromotionDetailsNotification
            closeModal={this.closeModal}
            id={modalProps.id}
          />
        )}
        {notificationModalType === MODIFIER_NOT_FOUND && (
          <ModifierNotFoundNotification
            closeModal={this.closeModal}
            message={modalProps.message}
          />
        )}
      </ModalRoot>
    );
  }
}

const mapStateToprops = state => {
  return {
    notificationModalType: state.notificationModal.notificationType,
    modalProps: state.notificationModal.modalProps
  };
};

export default connect(mapStateToprops)(NotificationModalContainer);
